import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiKey, ApiKeyService, NewApiKey, OAuthGrant } from '../../../services/api-key.service';
import { NotificationService } from '../../../util/errors/notification.service';

@Component({
    selector: 'api-keys-page',
    templateUrl: './api-keys-page.component.html'
})
export class ApiKeysPageComponent implements OnInit {

    keys: ApiKey[] = [];
    grants: OAuthGrant[] = [];
    form: FormGroup;
    createdKey: ApiKey;
    readonly mcpUrl: string = window.location.origin + '/ypm/api/mcp';

    constructor(private _apiKeyService: ApiKeyService,
                private _notificationService: NotificationService,
                private _formBuilder: FormBuilder) {
    }

    ngOnInit(): void {
        this.form = this._formBuilder.group({
            name: ['', Validators.required],
            expiresAt: ['']
        });
        this.loadKeys();
        this.loadGrants();
    }

    get mcpCommand(): string {
        const key = this.createdKey ? this.createdKey.key : '<api key>';
        return 'claude mcp add --transport http ypm ' + this.mcpUrl + ' --header "Authorization: Bearer ' + key + '"';
    }

    loadKeys(): void {
        this._apiKeyService.getKeys().subscribe(keys => this.keys = keys);
    }

    loadGrants(): void {
        this._apiKeyService.getOAuthGrants().subscribe(grants => this.grants = grants);
    }

    revokeGrant(grant: OAuthGrant): void {
        this._apiKeyService.revokeOAuthGrant(grant.id).subscribe(() => this.loadGrants());
    }

    create(): void {
        if (this.form.invalid) {
            return;
        }
        const newKey: NewApiKey = { name: this.form.value.name };
        if (this.form.value.expiresAt) {
            newKey.expiresAt = this.form.value.expiresAt;
        }
        this._apiKeyService.createKey(newKey).subscribe(created => {
            this.createdKey = created;
            this.form.reset({ name: '', expiresAt: '' });
            this.loadKeys();
        });
    }

    revoke(apiKey: ApiKey): void {
        this._apiKeyService.revokeKey(apiKey.id).subscribe(() => {
            if (this.createdKey && this.createdKey.id === apiKey.id) {
                this.createdKey = null;
            }
            this.loadKeys();
        });
    }

    copy(text: string): void {
        navigator.clipboard.writeText(text).then(
            () => this._notificationService.notify('Copiado al portapapeles'),
            () => this._notificationService.notify('No se pudo copiar; seleccione el texto y cópielo manualmente')
        );
    }
}
